export var ALERT_TYPE;
(function (ALERT_TYPE) {
    ALERT_TYPE[ALERT_TYPE["EMPTY_OPTION_WARNING"] = 0] = "EMPTY_OPTION_WARNING";
    ALERT_TYPE[ALERT_TYPE["DATE_RANGE_OPTION_ERROR"] = 1] = "DATE_RANGE_OPTION_ERROR";
    ALERT_TYPE[ALERT_TYPE["DATE_RANGE_EXPENSE_AND_REPORT_NUMBERS_INFO"] = 2] = "DATE_RANGE_EXPENSE_AND_REPORT_NUMBERS_INFO";
    ALERT_TYPE[ALERT_TYPE["DATE_RANGE_EXPENSE_NUMBERS_INFO"] = 3] = "DATE_RANGE_EXPENSE_NUMBERS_INFO";
    ALERT_TYPE[ALERT_TYPE["DATE_RANGE_EXPENSE_AND_REPORT_NUMBERS_ERROR"] = 4] = "DATE_RANGE_EXPENSE_AND_REPORT_NUMBERS_ERROR";
})(ALERT_TYPE || (ALERT_TYPE = {}));
export var CREATE_EXPENSE_REPORT_OPTIONS;
(function (CREATE_EXPENSE_REPORT_OPTIONS) {
    CREATE_EXPENSE_REPORT_OPTIONS[CREATE_EXPENSE_REPORT_OPTIONS["ALL_ITEMS"] = 0] = "ALL_ITEMS";
    CREATE_EXPENSE_REPORT_OPTIONS[CREATE_EXPENSE_REPORT_OPTIONS["CREDIT_CARD_TRANSACTIONS"] = 1] = "CREDIT_CARD_TRANSACTIONS";
    CREATE_EXPENSE_REPORT_OPTIONS[CREATE_EXPENSE_REPORT_OPTIONS["DATE_RANGE"] = 2] = "DATE_RANGE";
    CREATE_EXPENSE_REPORT_OPTIONS[CREATE_EXPENSE_REPORT_OPTIONS["BLANK"] = 3] = "BLANK";
    // TODO - add the rest of the options here when we have finalized them
    CREATE_EXPENSE_REPORT_OPTIONS[CREATE_EXPENSE_REPORT_OPTIONS["OPTION_5"] = 4] = "OPTION_5";
    CREATE_EXPENSE_REPORT_OPTIONS[CREATE_EXPENSE_REPORT_OPTIONS["OPTION_6"] = 5] = "OPTION_6";
})(CREATE_EXPENSE_REPORT_OPTIONS || (CREATE_EXPENSE_REPORT_OPTIONS = {}));
